import React from "react";
import { differenceInHours, formatDistance, getMonth, isAfter, isToday, isTomorrow } from "date-fns";
import { TIME_FORMAT } from "../../models/DateTime";
import { TimeTypes } from "../../models/DateTime";
import "../../styles/date/date-time-title.scss";
const HOURS_THRESHOLD_TO_SHOW_TIME_DISTANCE = 4;

const DateTimeTitle = ({
  dateTime,
  isSeason = false,
  isOther = false,
  isReturn = false,
  disableTimePicker = false
}) => {
  let formattedDate = "";
  let extraTitle = "";

  if (isSeason || isOther) {
    // SEASON
    if (isAfter(dateTime.toDate(), new Date())) {
      if (isToday(dateTime.toDate())) {
        formattedDate = "Today";
      } else if (isTomorrow(dateTime.toDate())) {
        formattedDate = "Tomorrow";
      } else {
        extraTitle = " on";
        formattedDate = `${dateTime.format("EEE do MMMM")}`;
      }
    } else {
      formattedDate = ""; // in the past
    } // END SEASON

  } else {
    // TICKETS
    if (isAfter(dateTime.toDate(), new Date())) {
      if (isToday(dateTime.toDate())) {
        formattedDate = "Today";

        if (!disableTimePicker) {
          const diffHours = differenceInHours(dateTime.toDate(), new Date());

          if (diffHours < HOURS_THRESHOLD_TO_SHOW_TIME_DISTANCE) {
            formattedDate = /*#__PURE__*/React.createElement(React.Fragment, null, "Today", " ", /*#__PURE__*/React.createElement("span", {
              className: "otrl-ui__date-time-title__time__exact--conjunction"
            }, " ", "in", " "), formatDistance(new Date(), dateTime.toDate()));
          } else {
            formattedDate = /*#__PURE__*/React.createElement(React.Fragment, null, "Today", /*#__PURE__*/React.createElement("span", {
              className: "otrl-ui__date-time-title__time__exact--conjunction"
            }, " ", "at", " "), dateTime.format(TIME_FORMAT));
          }
        }
      } else if (isTomorrow(dateTime.toDate())) {
        formattedDate = "Tomorrow";

        if (!disableTimePicker) {
          formattedDate = /*#__PURE__*/React.createElement(React.Fragment, null, "Tomorrow", " ", /*#__PURE__*/React.createElement("span", {
            className: "otrl-ui__date-time-title__time__exact--conjunction"
          }, " ", "at", " "), " ", dateTime.format(TIME_FORMAT));
        }
      } else {
        const dateFormat = getMonth(new Date()) !== getMonth(dateTime.toDate()) ? "do MMMM" : "EEEE do";
        formattedDate = dateTime.format(dateFormat);

        if (!disableTimePicker) {
          extraTitle = " on";
          formattedDate = /*#__PURE__*/React.createElement(React.Fragment, null, formattedDate, /*#__PURE__*/React.createElement("span", {
            className: "otrl-ui__date-time-title__time__exact--conjunction"
          }, " ", "at", " "), dateTime.format(TIME_FORMAT));
        }
      }
    } else {
      formattedDate = ""; // in the past
    } // END TICKETS

  }

  return /*#__PURE__*/React.createElement("div", {
    className: "otrl-ui__date-time-title__title-wrapper"
  }, isSeason ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "otrl-ui__date-time-title__title"
  }, "Season ticket", /*#__PURE__*/React.createElement("span", {
    className: "otrl-ui__date-time-title__title__color"
  }, !isReturn ? " starts " : " ends ", extraTitle)), /*#__PURE__*/React.createElement("h2", {
    className: "otrl-ui__date-time-title__time"
  }, /*#__PURE__*/React.createElement("span", {
    className: "otrl-ui__date-time-title__time__exact"
  }, formattedDate))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "otrl-ui__date-time-title__title"
  }, "I'm", /*#__PURE__*/React.createElement("span", {
    className: "otrl-ui__date-time-title__title__color"
  }, dateTime.timeType === TimeTypes.ARRIVING_AT ? " arriving " : isReturn ? " returning " : " departing ", extraTitle)), /*#__PURE__*/React.createElement("h2", {
    className: "otrl-ui__date-time-title__time"
  }, /*#__PURE__*/React.createElement("span", {
    className: "otrl-ui__date-time-title__time__exact"
  }, isOther ? formattedDate : dateTime.isDepartingNow() ? "Now" : formattedDate))));
};

export default DateTimeTitle;